// i18n area 'vms' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.et-EE.meta.json.
import type { enUS } from './vms'

export const etEE: typeof enUS = {
  vms: {
    spof: {
      title: 'Sõltumatus sõlmest',
      single: 'Üksik tõrkepunkt',
      alternativesNow: 'Alternatiivid praegu',
      structural: 'Konstruktsiooni järgi',
      binding: 'Siduv piirang',
      movableNow: 'Migreeritav praegu',
    },
    title: 'Virtuaalmasinad',
    migratingChip: 'Migratsioon käib',
    templateChip: 'Template',
    expendableTooltip: 'Halvenenud klastris on see esimeste seas, mis peatatakse, ega pruugi pärast sõlme kaotust taaskäivituda.',
    expendableHaTooltip: 'Käivitatakse alati uuesti, kuni klaster on terve; halvenenud klastris on kaitstud VM-id esikohal — selle võib peatada või see võib jääda välja, kuni klaster on taas terviklik, seejärel naaseb see ise.',
    viewDetails: 'Vaata üksikasju',
    profileLegacy: 'Muu OS',
    hugePagesNone: 'Puudub — tavaline mälu',
    hugePages2M: '2 MiB leheküljed',
    hugePages1G: '1 GiB leheküljed',
    searchPlaceholder: 'Otsi nime järgi',
    name: 'Nimi',

    // ÜHTNE terminoloogia (#94a): phase'i nimi on kõikjal 'Faas' — vana
    // võti 'state' suri loendi viimistlusega.
    vcpus: 'vCPU',
    memory: 'Mälu',
    ipAddresses: 'IP-aadressid',
    noIp: 'IP-d ei ole',
    authorityNode: 'Authority',
    authorityNextStart: 'määratakse järgmisel käivitusel',
    scope: 'Scope',
    empty: 'Ühtegi virtuaalmasinat ei ole',
    loadError: 'Virtuaalmasinaid ei õnnestunud laadida — kas TVirti backend on kättesaadav?',
    filterOverlay: 'overlay-võrk',
    filterDisk: 'ketas',
    filterImage: 'tõmmis',
    filteredBy: 'Filtreeritud: {kind}',
    filterPhase: 'Faas',
    filterProtection: 'Kaitse',
    filterAll: 'Kõik',
    filterScopePlaceholder: 'Filtreeri scope järgi',
    filtersToggle: 'Filtrid',
    scopeTree: {
      title: 'Scope',
      all: 'Kogu klaster',
      noChildren: "Siin ei ole ühtegi alam-scope'i",
      recursive: 'Kaasa järglased',
      collapse: "Ahenda scope'i paneel",
      up: 'Liigu tase ülespoole',
      countTooltip: "{direct} VM-i selles scope'is · {total} koos järglastega"
    },

    // Kaheastmeline ISO-valija (#85): kõigepealt kataloog, siis selle ISO-d.
    isoPicker: {
      catalog: 'Kataloog',
      unknownCatalog: 'Väljaspool nähtavaid katalooge',
      noIsos: 'Selles kataloogis ei ole ühtegi valmis ISO-tõmmist'
    },
    actionsHeader: 'Toimingud',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Riistvara',
      tags: 'Sildid',
      age: 'Vanus',
      disk: 'ketas',
      disks: 'ketast',
      empty: "Ühtegi template'it ei ole — märgi mõni väljalülitatud VM template'iks või klooni VM template'ina.",
      clone: 'Klooni / juuruta',
      editTags: 'Muuda silte',

      // Ring K3 (#64): ekspordib template'i kataloogi .tvtpl-failina.
      exportAction: 'Ekspordi kataloogi (.tvtpl)',
      exportTitle: 'Ekspordi kataloogi',
      exportSubmit: 'Ekspordi',
      exportError: 'Eksport ebaõnnestus',
      exportHint: "Template pakitakse .tvtpl-arhiivi (riistvara manifest + iga ketas qcow2-ks lamendatuna) uue VM-template failina valitud kataloogis. NIC-id, CD/DVD-kandjad ja cloud-init kaasa ei rända — vormingu spetsifikatsioon loetleb iga teadliku väljajätmise.",
      exportName: 'Faili nimi',
      exportNameHint: 'Tühi = <template>-export-<n>',
      exportStorageDefault: "Template'i metaandmete storage",

      // Impordi kataloogist (Luca 2026-08-03): Template'ite saki tööriistariba
      // sissepääs — K3/K4 backend katab kõik vm-template vormingud, valida
      // tuleb FAIL (vorming rändab kaasa ainult lugemiseks).
      importAction: 'Impordi kataloogist',
      importTitle: 'Impordi kataloogist',
      importHint: 'Valitud kataloogi valmis VM-template failist saab inventari template: faili vorming (tvtpl, ova, ovf või paljas qcow2) otsustab ise, kuidas see imporditakse — sina valid ainult faili.',
      importFile: 'Kataloogifail',
      importFileHint: 'Imporditakse ainult valmis faile — poolelioleva üleslaadimisega faili importida ei saa',
      importNoFiles: 'Selles kataloogis ei ole ühtegi valmis VM-template faili — lae või ekspordi enne üks siia'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy ühilduvus',
      quickDeployNone: 'Deklareerimata',
      quickDeployHint: 'Deklareeri see ainult siis, kui golden-tõmmis sisaldab cloud-init\'i (Linux) või cloudbase-init\'i pärast sysprep /generalize\'i (Windows): platvorm usaldab deklaratsiooni ega vaata kunagi külalise sisse.',
      notFound: "Template'it ei leitud",
      frozen: 'Riistvara seadistus on külmutatud: selle muutmiseks teisenda template tagasi VM-iks. Nimi, märkmed ja sildid jäävad muudetavaks.',
      storage: 'Storage',
      size: 'Suurus',
      configTitle: 'Seadistus (külmutatud)',
      usbClasses: 'Nõutavad USB-klassid',
      gpuClasses: 'Nõutavad GPU-klassid'
    },
    sharedDisksTab: {
      title: 'Jagatud kettad',
      sharing: 'Jagamine',
      sharingNone: 'Üks ühendus',
      sharingMultiwriter: 'Jagatud kirjutamine (multiwriter)',
      sharingReadonly: 'Jagatud kirjutuskaitstud',
      usedBy: 'Kasutab',
      attachedTo: 'Ühendatud',
      notAttached: 'Pole ühendatud ühegi VM-iga',
      changeSharing: 'Muuda jagamisrežiimi',
      changeSharingTitle: 'Jagamisrežiim',
      changeSharingLocked: 'Režiimi saab muuta ainult siis, kui ükski VM ketast ei kasuta',
      sharingChanged: 'Jagamisrežiim uuendatud.',
      lun: 'Terve LUN',
      lunNumber: 'LUN / nimeruum',
      lunWwn: 'WWN',
      lunSerial: 'Seerianumber',
      antiAffinityWarning: 'Kaks või enam liiget töötavad samas sõlmes ilma anti-afiinsuse reeglita: ühe sõlme rike võtab kõik maha',
      antiAffinityCreate: 'Loo reegel',
      createSourceLun: 'Võta üle sihtmärgi terve LUN',
      createLunNumber: 'LUN-i number (nimeruumi id NVMe puhul)',
      createLunHint: 'Midagi ei eraldata: suurus loetakse ülevõtmisel seadmelt',
      noPr: 'Selles väljalaskes pole SCSI-3 persistent reservations: klassikalise jagatud kettaga Windows Failover Cluster pole valideeritud; võrgu kaudu koordineeruvad klastrid (GFS2/OCFS2, RHEL HA, jagatud kettaga andmebaasid) on'
    },
    unusedDisksTab: {
      title: 'Kasutamata kettad',
      attach: 'Ühenda VM-iga',
      attachTitle: 'Ühenda VM-iga',
      vm: 'Virtuaalmasin',
      noVms: 'Ühtegi VM-i ei ole saadaval',
      noSlots: 'Sellel VM-il ei ole ühtegi vaba pesa',

      // Eraldiseisva ketta loomine (#87): naasis pensionile saadetud
      // Inventarist, nüüd SELGESÕNALISE scope-väljaga (pole VM-i, kellelt pärida).
      create: 'Loo ketas',
      createTitle: 'Loo ketas',
      createSourceBlank: 'Tühi ketas',
      createSourceImage: 'Kataloogi tõmmisest',
      createImage: 'Tõmmis',
      createImageEmpty: 'Nähtavates kataloogides pole ühtegi valmis VM-malli tõmmist',
      createSizeFromImageHint: 'Eeltäidetud tõmmise virtuaalse suurusega — saab ainult kasvada',

      // #107 (HÄVITAV, ratifitseeritud): qcow2 → vm-template kataloogifail
      // samal storage'il, null kopeeritud baiti — ketas lakkab olemast.
      convert: "Teisenda VM-template'iks…",
      convertOnlyQcow2: 'Teisendada saab ainult qcow2-kettaid — raw ei ole registreeritav template-vorming',
      convertTitle: "Teisenda VM-template'iks",
      convertSubmit: 'Teisenda (hävitab ketta)',
      convertError: 'Teisendust ei õnnestunud käivitada',
      convertWarning: "HÄVITAV: kettast saab valitud kataloogis VM-template fail — sama storage, null kopeeritud baiti — ja ta LAKKAB kettana olemast. Tagasiteed ei ole muidu, kui luua template'ist uus ketas.",
      convertNameHint: 'Kataloogifaili nimi — vaikimisi ketta oma',
      convertConfirm: 'Sain aru: ketas hävitatakse',
      convertStarted: 'Teisendus käivitatud — template ilmub kataloogi, kui task lõpeb.',
      storageLockHint: 'Storage muutub ainult tegevusega Teisalda',
      source: 'Päritolu',
      sourceClone: 'Teise ketta kloon',
      sourceCloneLinked: 'Teise ketta linked clone',
      sourceImage: 'Loodud tõmmisest',
      sourceBlank: 'Loodud tühjana',
      allocated: 'Eraldatud / virtuaalne suurus',
      observedAt: 'Vaadeldud',
      snapshots: "Snapshot'id",
      snapshotsEmpty: "Ühtegi snapshot'i ei ole"
    },
    phase: {
      defined: 'Pole kunagi käivitatud',
      starting: 'Käivitumas',
      running: 'Töötab',
      stopping: 'Seiskumas',
      stopped: 'Välja lülitatud',
      paused: 'Pausil',
      failed: 'Veaolekus',
      deleting: 'Kustutamisel'
    },
    stopCause: {
      'api': 'TVirt seiskas (toiming või API)',
      'guest-shutdown': 'Külalise operatsioonisüsteemi algatatud väljalülitus',
      'crash': 'Külalise krahh',
      'qemu-exit': 'QEMU protsess lõpetas ootamatult',
      'host-reboot': 'Sõlm taaskäivitati',
      'migrated': 'Migreeritud teisele sõlmele',
      'fenced': 'HA-fencing lõpetas töö (sõlm naasis)'
    },
    detail: {
      notFound: 'Virtuaalmasinat ei leitud',
      details: 'Üksikasjad',
      id: 'ID',
      scope: 'Scope',
      profile: 'Riistvaraprofiil',
      firmware: 'Püsivara',
      firmwareFile: 'UEFI püsivara versioon',
      firmwareUpdate: 'Uuendus saadaval',
      firmwareUpdateHint: 'Platvorm tarnib uuema UEFI püsivara. Uuendus ei toimu kunagi automaatselt: see rakendub väljalülitatud VM-il, kui sina nii otsustad.',
      arch: 'Arhitektuur',
      node: 'Sõlm',
      bootOrder: 'Alglaadimise järjekord',
      agent: 'Agendi olek',
      agentConnected: 'Ühendatud',
      agentNotConnected: 'Ühendamata',
      protected: 'Kaitstud',
      linkedClones: "Linked clone'id",
      restartPolicy: 'Taaskäivituspoliitika',
      preferredNode: 'Eelistatud sõlm',
      noPreference: 'Eelistust ei ole (automaatne paigutus)',
      preferNodes: 'Eelistatud sõlmesildid',
      requireNodes: 'Kohustuslikud sõlmesildid',
      noPlacementTags: 'Ei ühtegi',
      placementTag: 'Silt',
      placementValue: 'Väärtus',
      placementAddTag: 'Lisa silt',
      proximityHa: 'TVirt Proximity HA',
      proximityHaRestarts: 'HA-taaskäivitust',
      proximityHaGaveUp: 'krahhitsükkel — HA andis alla',
      failoverProtection: 'Kaitse halvenenud klastris',
      protectionProtected: 'Kaitstud',
      protectionExpendable: 'Ohverdatav halvenemisel',
      protectionInherit: 'Päri',
      lastStop: 'Viimane seiskamine',
      yes: 'Jah',
      no: 'Ei',
      tabOverview: 'Ülevaade',
      tabSnapshots: "Snapshot'id",
      tabBackups: 'Varukoopiad',
      hardware: 'Riistvara',
      name: 'Nimi',
      hwSystem: 'Süsteem',
      hwCpu: 'CPU',
      hwMemory: 'Mälu',
      hwBoot: 'Alglaadimine',
      hwIdentity: 'Identiteet',
      hwCluster: 'Klaster ja agent',
      cpuTopology: 'CPU topoloogia',
      cpuModel: 'CPU mudel',
      cpuLimit: 'CPU piirang',
      cpuWeight: 'CPU kaal',
      cpuNested: "Pesastatud virtualiseerimine",
      cpuNestedHint: "Avab külalisele vmx/svm (ainult CPU mudeliga host). Töötaval VM-il jõustub muudatus järgmise power cycle ajal (PendingRestart); paigutus lubab ainult sõlmi, kus nested on lubatud.",
      unlimited: 'Piiramatu',
      memory: 'Mälu',
      balloon: 'Balloon',
      hugePages: 'Hiiglaslikud leheküljed',
      hugePagesTradeoff: 'Vähem aadressiteisendustööd ja mälu, mis ei satu kunagi kettale; vastutasuks jääb reservatsioon sõlme külge lukku, kuni VM töötab, mälu enam ei dedupleerita ja käivitus ebaõnnestub, kui sõlmel on liiga vähe vabu lehekülgi.',
      disks: 'Kettad',
      cdroms: 'CD/DVD-seadmed',
      nics: 'Võrguliidesed',
      slot: 'Pesa',
      disk: 'Ketas',
      encrypted: 'Krüpteeritud',
      image: 'Tõmmis',
      emptyDrive: 'Tühi seade',
      emptyOption: '(tühi)',
      network: 'Võrk',
      mac: 'MAC',
      connected: 'Ühendatud',
      unplugged: 'Lahti ühendatud',
      noDevices: 'Ei ühtegi',
      screenshot: 'Ekraanitõmmis',
      capturedAt: 'Jäädvustatud',
      noCapture: 'Jäädvustust ei ole',
      snapshotName: 'Nimi',
      snapshotCreated: 'Loodud',
      snapshotMemory: 'Mälu on kaasatud',
      noSnapshots: "Ühtegi snapshot'i ei ole",
      pendingRestart: 'Ootel muudatused: need rakenduvad järgmisel toitetsüklil.',
      applied: 'rakendatud',
      appliedHint: 'VM töötab selle väärtusega — seadistatud väärtus rakendub järgmisel toitetsüklil.',
      actionError: 'Toiming ebaõnnestus',
      actionStillRunning: 'Toiming on veel pooleli — tulemus pole veel teada',
      tabConsole: 'Konsool',
      consoleConnect: 'Ühenda',
      consoleDisconnect: 'Ühenda lahti',
      consoleConnecting: 'Ühendamine…',
      consoleReconnecting: 'Ühendamine…',
      consoleUnavailable: 'Konsool on saadaval, kui VM töötab või on pausil.',
      consoleError: 'Konsooliga ühendumine ebaõnnestus',
      consoleTaken: 'Konsoolisessiooni võttis endale {user}',
      consoleReconnect: 'Ühenda uuesti',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Hoia all {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Ava täisekraanil uuel sakil',
      consoleLoadFailed: 'VM-i ei leitud või õigustest ei piisa',
      consoleClose: 'Sulge',
      tabStats: 'Statistika',
      tabTasks: 'Taskid',
      tabLogs: 'Logi',
      statsCpu: 'CPU',
      statsMemory: 'Mälu',
      statsDisk: 'Ketta I/O',
      statsRange: 'Vahemik',
      statsNoData: 'Selles vahemikus andmeid ei ole — statistikat kogutakse siis, kui VM töötab.',
      statsError: 'Statistikat ei õnnestunud laadida',
      cpuUsage: 'Kasutus',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Kasutatud',
      memGuestAvailable: 'Saadaval (külaline)',
      schema: 'Skeem',
      consoleProtocol: 'Konsool',
      agentEnabled: 'Külalise agent',
      metadataStorage: 'Metaandmete storage',
      startupOnBoot: 'Käivitus alglaadimisel',
      startupOrder: 'Käivitusjärjekord',
      startupDelay: 'Käivitusviivitus',
      seconds: 's',
      enabled: 'Lubatud',
      disabled: 'Keelatud'
    },
    actionsAvailable: 'Saadaolevad toimingud',
    actions: {
      start: 'Käivita',
      stop: 'Seiska',
      pause: 'Pane pausile',
      resume: 'Jätka',
      reset: 'Lähtesta',
      migrate: 'Migreeri',
      clone: 'Klooni',
      moveStorage: "Teisalda storage'ile…",
      moveScope: "Teisalda scope'i…",
      openConsole: 'Ava konsool',
      forceStop: 'Sundväljalülitus',
      markTemplate: "Märgi template'iks",
      unmarkTemplate: 'Teisenda tagasi VM-iks',
      error: 'Toimingut ei õnnestunud sooritada'
    },
    cordon: {
      confirmTitle: 'Sõlm on hoolduses',
      confirmHint:
        'Kordonit ei saa langetada, kuni klastri store on maas. Kinnitades kinnitad, et tead seda: VM käivitub seal sellegipoolest ja nõusolek jääb ülesandele kirja.',
      confirm: 'Käivita sellegipoolest'
    },
    markTemplate: {
      confirmTitle: "Kas märkida {name} template'iks?",
      confirmBody: 'Seadistus külmutatakse ja VM ei saa enam käivituda — teda saab ainult kloonida või tagasi VM-iks teisendada. Nimi, märkmed ja sildid jäävad muudetavaks.',
      confirm: "Märgi template'iks",
      moved: "{name} on nüüd template — ta liikus Template'ite sakile."
    },
    unmarkTemplate: {
      confirmTitle: 'Kas teisendada {name} tagasi VM-iks?',
      confirmBody: "Template'ist saab tavaline VM: muudetav ja käivitatav (järgmine käivitus paigutab ta mõnele sõlmele).",
      confirm: 'Teisenda tagasi VM-iks',
      moved: '{name} on taas virtuaalmasin — ta liikus Virtuaalmasinate sakile.'
    },

    // Ring #123: sõlmele viitamine SILDI kaudu (selektor #106) käivitus- ja
    // migratsioonidialoogides — koos lahendatud hulga eelvaatega.
    nodeByTag: {
      label: 'Sõlmesildi järgi',
      hint: 'silt=väärtus, komadega eraldatuna (JA-loogikaga): otsustaja valib vastavate sõlmede seast',
      invalid: 'Vigane vorming — kasuta silt=väärtus, komadega eraldatuna',
      resolved: 'Vastavad liikmed: {nodes}'
    },
    migrate: {
      title: 'Live-migratsioon',
      submit: 'Migreeri',
      target: 'Sihtsõlm',
      auto: 'Automaatne (Proximity)',
      hint: 'VM liigub ilma toitetsüklita. Iga storage, mida ta puudutab, peab olema jagatud; pausil VM migreerub pausil.',
      error: 'Migratsioon lükati tagasi'
    },
    moveStorage: {
      title: "Teisalda storage'ile",
      submit: 'Teisalda',
      target: 'Siht-storage',
      noTargets: 'Ükski storage ei võta kettaid vastu',
      hint: "Kõik väljalülitatud VM-i kettad rändavad ükshaaval valitud storage'ile, säilitades oma ID — need, mis on juba sihtkohas, jäetakse vahele. Edenemine elab taskide lehel.",
      error: 'Teisaldamine lükati tagasi'
    },
    moveScope: {
      title: "Teisalda scope'i",
      submit: 'Teisalda',
      target: 'Siht-scope',
      hint: "VM vahetab scope'i kohe — ID ja kettad jäävad alles, talle kuuluvad kettad järgnevad talle ja ta võib jääda käima. Täna elab ta scope'is {scope}. See, kes teda näeb, muutub koos scope'iga.",
      error: "Scope'i vahetus lükati tagasi"
    },
    start: {
      title: 'Käivita VM',
      submit: 'Käivita',
      target: 'Sihtsõlm',
      auto: 'Automaatne (soovitatav)',
      recommended: 'soovitatav',
      hint: 'Vali sihtsõlm või lase Proximityl kehtivate kandidaatide seast otsustada. Sõlmed, kes teda majutada ei saa, on koos põhjusega keelatud.',
      error: 'VM-i ei õnnestunud käivitada'
    },
    console: {
      media: 'CD/DVD-seadmed',
      mediaGuestToolsHint: 'Sisaldab TVirt Guest Toolsi — siit saad selle väljastada või seadme eemaldada',
      slotOpsDeferred: 'Sellel profiilil rakenduvad seadmete lisamine ja eemaldamine järgmisel toitetsüklil (kandja vahetused on kohesed).',
      mountGuestTools: 'Haagi TVirt Guest Tools',
      ejectGuestTools: 'Väljasta TVirt Guest Tools',
      bootOrder: 'Alglaadimise järjekord',
      bootOrderHint: 'Uus järjekord salvestatakse kohe ja rakendub järgmisel toitetsüklil — konsoolisessioon jääb ühendatuks.'
    },
    snapshots: {
      create: 'Loo snapshot',
      createTitle: 'Loo snapshot',
      createSubmit: 'Loo',
      name: 'Nimi',
      nameHint: 'Tähed, numbrid, punkt, sidekriips, alakriips.',
      consistencyHint: "Kooskõlalisus on automaatne: külalise agent külmutab failisüsteemid, kui ta vastab; muidu läheb VM snapshot'i ajaks hetkeks pausile.",
      memory: 'Kaasa mälu',
      memoryHint: 'Jäädvustab elava RAM-i: taastamine jätkab VM-i töötavana. Nõuab, et kõik kettad oleksid qcow2.',
      currentChip: 'Sa oled siin',
      revert: 'Taasta',
      revertTitle: 'Kas taastada {name}?',
      revertBody: "Kettad naasevad snapshot'i olekusse; kõik, mis pärast juhtus, läheb kaotsi. Ainult ketaste snapshot nõuab seisvat VM-i.",
      delete: 'Kustuta',
      deleteTitle: 'Kas kustutada snapshot {name}?',
      deleteBody: 'Taastepunkt kaob; ketaste sisu jääb puutumata.',
      deleteMergeHint: 'Selle delta liidetakse siia: {children}; iga hilisem taastepunkt jääb kehtima.',
      deleteDuplication: 'Nõustun dubleerimisega',
      deleteDuplicationHint: 'Delta kopeeritakse igasse {count} lugejasse (alam-snapshotid ja, kui see on praegune, aktiivne pea): kasutatud ruum võib kahanemise asemel kasvada.',
      error: "Snapshot'i toiming lükati tagasi"
    },
    clone: {
      title: 'Klooni VM',
      submit: 'Klooni',
      name: 'Koopia nimi',
      storage: 'Ketaste siht-storage',
      sameStorage: 'Sama mis lähtekohas',
      full: 'Täiskoopia',
      fullHint: 'Kopeerib iga baidi ja katkestab sideme lähteketastega. Vaikimisi tehakse linked clone: hetkeline, kuid lähtekoha külge aheldatud (ainult qcow2).',
      hint: 'Kloon säilitab lähtekoha seadistuse ja püsivara; MAC-aadressid ja TPM-identiteet on uued.',
      markAs: 'Klooni tüüp',
      markAsInheritVm: 'Nagu lähtekoht (VM)',
      markAsInheritTemplate: 'Nagu lähtekoht (template)',
      markAsVm: 'Virtuaalmasin',
      markAsTemplate: 'Template',
      markAsHintVm: 'Vali Template, et ülendada koopia ühe sammuga.',
      markAsHintTemplate: "Vali Virtuaalmasin, et sellest template'ist ühe sammuga juurutada.",
      error: 'Kloonimine lükati tagasi'
    },
    bulk: {
      selected: 'valitud',
      deleteTitle: {
        one: 'Kas kustutada {count} valitud VM?',
        other: 'Kas kustutada {count} valitud VM-i?'
      },
      deleteBody: 'Iga VM läbib samad valvurid nagu üksikkustutamine; tagasilükkamised raporteeritakse elemendi kaupa.',
      done: 'vastu võetud',
      refused: 'tagasi lükatud'
    },
    delete: {
      button: 'Kustuta',
      confirmTitle: 'Kas kustutada {name}?',
      confirmBody: 'Virtuaalmasin ja talle kuuluvad kettad kustutatakse. Toiming ei ole tagasipööratav.',
      keepDisks: 'Säilita kettad',
      keepDisksHint: "VM-iga koos loodud kettad jäävad oma storage'ile iseseisvate ketastena.",
      confirm: 'Kustuta',
      cancel: 'Loobu',
      error: 'Kustutamine ebaõnnestus',
      blockedPhase: 'Seiska enne VM',
      blockedProtected: 'VM on kaitstud — eemalda enne kaitse',
      blockedDeleting: 'Kustutamine juba käib'
    },
    logs: {
      title: 'Logi',
      subtitle: 'Seda VM-i puudutavate taskide struktureeritud logikaadrid',
      when: 'Millal',
      task: 'Task',
      level: 'Tase',
      message: 'Sõnum',
      empty: 'Logisid veel ei ole',
      loadError: 'Logisid ei õnnestunud laadida — kas TVirti backend on kättesaadav?'
    },
    stop: {
      title: 'Seiska virtuaalmasin',
      modeGraceful: 'Sujuv väljalülitus',
      modeGracefulHint: 'Külalise operatsioonisüsteemil palutakse loomulikul teel välja lülituda (ACPI); kui ta palvet eirab, käivitub pärast ajapiirangut sundväljalülitus.',
      modeForced: 'Sundväljalülitus',
      modeForcedHint: 'Katkestab voolu kohe, nagu pistiku seinast tõmbamine.',
      timeout: 'Varuvariandi ajapiirang (sekundites)',
      timeoutHint: 'Külalisele antav ooteaeg enne väljalülituse sundimist'
    },

    // Loomisnupu jaotatud menüü (Luca 2026-07-23): "Nullist" avab viisardi,
    // ülejäänud kaks kirjet on teekaardi tüngad.
    createFromScratch: 'Nullist',
    createFromTemplate: "Template'ist",
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Käivita deploy',
      error: 'Deploy ebaõnnestus',
      compatNote: 'QuickDeploy nõuab QuickDeploy-ga ühilduvat malli: platvorm kohandab külalist (võrk, domeen, aktiveerimine) esimesel käivitusel.',
      template: 'Mall',
      noTemplates: 'Ükski mall ei deklareeri veel QuickDeploy ühilduvust — deklareeri see vahekaardil Mallid (Linux cloud-init\'iga, Windows cloudbase-init\'iga pärast sysprep\'i)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Hostinimi',
      hostnameHint: 'Hostinimi või FQDN; tühi = VM-i nimi (Windows: kuni 15 märki)',
      ip: 'IP-aadress',
      ipHint: 'Host ja prefiks, nt 192.168.122.101/24; tühi = DHCP',
      gateway: 'Lüüs',
      dns: 'DNS-serverid',
      dnsHint: 'Kuni kolm, komaga eraldatud',
      count: 'Eksemplarid',
      countHint: 'Rohkem kui üks: nimega <nimi>-1…-N, ainult DHCP',
      user: 'Kasutaja',
      userHint: 'Tühi = tõmmise vaikekasutaja (Linux) või Administrator (Windows)',
      password: 'Parool',
      passwordHint: 'Kirjutatakse genereeritud user-data\'sse, mille platvorm seejärel salajaseks deklareerib: keegi ei loe seda enam',
      sshKeys: 'SSH avalikud võtmed',
      sshKeysHint: 'Üks rea kohta (ssh-ed25519 AAAA… kommentaar)',
      productKey: 'Windowsi tootevõti',
      kmsServer: 'KMS-server',
      kmsHint: 'Host või host:port — nõuab tootevõtit (KMS-i kliendivõtit)',
      adDomain: 'Liitu Active Directory domeeniga',
      adDomainHint: 'Tühi = domeeniga ei liituta',
      adUser: 'Liitumiskonto',
      adPassword: 'Liitumiskonto parool',
      adOu: 'Siht-OU (valikuline)',
      advanced: 'Täpsem: toordokumendid',
      userData: 'user-data (toores)',
      userDataHint: 'Asendab genereeritud user-data: kasutaja, parool, võtmed ja ülal olevad Windowsi väljad peavad jääma tühjaks',
      networkConfig: 'network-config (toores)',
      networkConfigHint: 'Asendab genereeritud võrgu: IP, lüüs ja DNS ülal peavad jääma tühjaks',
      secret: 'Käsitle toorest user-data\'t salajasena',
      secretHint: 'Salajaseks märgituna ei tagasta API seda enam kellelegi ja Checkpointis liigub see masterpass\'iga pitseerituna',
      startNow: 'Käivita kohe',
      startNowHint: 'Iga eksemplar käivitub kohe pärast defineerimist; seed luuakse sel käivitusel'
    },

    create: {
      nicAttachmentNetwork: 'Loogiline võrk (fabric)',
      nicNetwork: 'Loogiline võrk',
      nicNetworkHint: 'SOOVITATUD tee (F3): vNIC realiseerub teeniva node\'i TULETATUD sillal — sild sünnib fabricu eksplitsiitsel apply\'l ja käivitus node\'il, mis seda veel ei kanna, keeldub rääkides. Kui laevastiku viimane viide lahkub, kukub sild järgmisel apply\'l välja.',
      button: 'Loo VM',
      title: 'Loo virtuaalmasin',
      dialogTitle: 'Loo virtuaalmasin',
      stepGeneral: 'Üldine',
      stepGeneralHint: 'Nimi ja profiil',
      stepCompute: 'CPU ja RAM',
      stepComputeHint: 'Topoloogia ja suurused',
      stepDisks: 'Kettad',
      stepDisksHint: 'Loo või ühenda',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Seadmed ja kandjad',
      stepNetwork: 'Võrk',
      stepNetworkHint: 'NIC: trunk või bridge',
      stepSummary: 'Kokkuvõte',
      stepSummaryHint: 'Kontrolli ja loo',
      name: 'Nimi',
      nameHint: 'Väiketähed, numbrid ja sidekriipsud (DNS-1123)',
      nextButton: 'Edasi',
      prevButton: 'Tagasi',
      submitButton: 'Loo',
      creating: 'Loomine…',
      sockets: 'Soklid',
      cores: 'Tuumi sokli kohta',
      threads: 'Lõimi tuuma kohta',
      totalVcpus: 'vCPU-sid kokku',
      memoryGib: 'Mälu (GiB)',
      cpuModelHint: "'host' avab hosti CPU külalisele",
      cpuLimitHint: 'Ülempiir hosti tuumades — tühi = piiramatu',
      cpuNestedHint: "Avab külalisele vmx/svm, et see saaks käitada oma hüperviisorit — nõuab CPU mudelit host ja sõlme, kus nested on lubatud",
      newDisk: 'Uus ketas',
      attachDisk: 'Ühenda olemasolev ketas',
      diskStorage: 'Storage',
      diskSize: 'Suurus (GiB)',
      diskSelect: 'Ketas',
      addDisk: 'Lisa ketas',
      addCdrom: 'Lisa CD/DVD-seade',
      addNic: 'Lisa võrguliides',
      remove: 'Eemalda',
      slotLimit: 'Pesade piir on täis',
      cdromImage: 'Tõmmis (puudumisel tühi seade)',
      nicAttachment: 'Ühendus',
      nicAttachmentTrunk: 'Overlay-trunk',
      nicAttachmentBridge: 'Hosti bridge',
      nicUntagged: 'Sildistamata overlay',
      nicUntaggedNone: 'Ei ühtegi (ainult sildistatud)',
      nicTrunkHint: 'Vähemalt üks pool: sildistamata overlay ja/või sildistatud VLAN-vastendused — VM saab joosta ainult nendel hostidel, mille iga viidatud overlay deklareerib',
      nicTaggedVlan: 'VLAN-i ID',
      nicTaggedOverlay: 'Overlay-võrk',
      addTagged: 'Lisa sildistatud VLAN',
      nicBridge: "Hosti bridge'i nimi",
      nicBridgeHint: "NM-bridge nime järgi — VM saab joosta ainult nendel serveritel, mille hosti võrk selle bridge'i deklareerib",
      nicMac: 'MAC (tühjana automaatne)',
      noDisksHint: 'Ühtegi ketast ei ole: VM-il on ainult need CD/DVD-seadmed, mille sa lisad.',
      noCdromsHint: 'Ühtegi CD/DVD-seadet ei ole: lisa üks, et ISO-tõmmiselt käivituda.',
      mountGuestTools: 'Haagi TVirt Guest Tools esimesel käivitusel',
      mountGuestToolsHint: 'Paneb virtio-draiverite ja külalise agendiga ISO tühja CD-seadmesse (lisatakse vajadusel) — Windowsi installer vajab seda ketaste nägemiseks.',
      noNicsHint: 'Ühtegi võrguliidest ei ole: VM käivitub ilma ühenduseta.',
      taggedMappings: 'Sildistatud VLAN-i vastendused',
      summaryDevices: 'Seadmed',
      bootOrderTitle: 'Alglaadimise järjekord',
      bootOrderHint: 'Lohista, et järjekorda muuta — võidab esimene alglaaditav seade; NIC-id käivitavad PXE',
      bootOrderUp: 'Liiguta üles',
      bootOrderDown: 'Liiguta alla',
      createError: 'Loomine ebaõnnestus'
    },
    edit: {
      button: 'Muuda',
      title: 'Muuda virtuaalmasinat',
      cancel: 'Loobu',
      save: 'Salvesta',
      error: 'Muutmine ebaõnnestus',
      modelStoppedOnly: 'Muudetav ainult väljalülitatud VM-il',
      firmwareStoppedOnly: 'Püsivara saab muuta ainult väljalülitatud VM-il — järgmisel käivitusel käivitub masin uue püsivaraga ja UEFI muutujad jäävad alles',
      hugePagesStoppedOnly: 'Muudetav ainult väljalülitatud VM-il — järgmisel käivitusel sünnib mälu uuel alusel',
      runningHint: 'Muudatused rakenduvad järgmisel toitetsüklil',
      sectionCpu: 'CPU',
      sectionMemory: 'Mälu',
      sectionPolicy: 'Poliitikad'
    },
    devices: {
      networkChip: 'fabricu võrk',
      title: 'Seadmed',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Lisa USB-seade',
      addUsbTitle: 'Nõua USB-seadmete klassi',
      usbClassHint: 'VM küsib USB-seadmete KLASSI (usb-device sildi väärtust), mitte kunagi konkreetset seadet: käivitusel valitakse ja reserveeritakse sõlmel konkreetne vaba seade. Sildista seadmed, mis on registreeritud jaotises Klaster › USB- ja PCIe-ressursid.',
      usbTag: 'Silt (usb-device)',
      usbValue: 'Klassi väärtus',
      noUsbTags: 'Ühtegi usb-device silti ei ole — loo üks ja sildista seadmed, mis on registreeritud jaotises Klaster › USB- ja PCIe-ressursid.',
      noUsbValues: 'Sellel sildil ei ole veel ühtegi deklareeritud väärtust.',
      usbEmpty: 'USB-nõudeid ei ole — lisa klass, et käivitusel seade läbi anda.',
      usbClassChip: 'klass',
      usbPortChip: 'port',
      usbUnclaimed: 'Ühtegi seadet ei ole reserveeritud — see lahendatakse VM-i käivitusel.',
      addGpu: 'Lisa GPU',
      addGpuTitle: 'Nõua GPU klassi',
      gpuClassHint: 'VM küsib GPU KLASSI (gpu-device sildi väärtust), mitte kunagi konkreetset kaarti: käivitusel valitakse ja reserveeritakse sõlmel konkreetne vaba kaart ning KOOS temaga antakse läbi kogu tema IOMMU-grupp. Sildista GPU-d, mis on registreeritud jaotises Klaster › USB- ja PCIe-ressursid.',
      gpuTag: 'Silt (gpu-device)',
      gpuValue: 'Klassi väärtus',
      noGpuTags: 'Ühtegi gpu-device silti ei ole — loo üks ja sildista GPU-d, mis on registreeritud jaotises Klaster › USB- ja PCIe-ressursid.',
      noGpuValues: 'Sellel sildil ei ole veel ühtegi deklareeritud väärtust.',
      gpuEmpty: 'GPU-nõudeid ei ole — lisa klass, et käivitusel kaart läbi anda.',
      gpuClassChip: 'klass',
      gpuGroupChip: 'IOMMU-grupp ×',
      gpuUnclaimed: 'Ühtegi kaarti ei ole reserveeritud — see lahendatakse VM-i käivitusel.',
      gpuPowerCycle: 'GPU hotplugi ei ole — muudatused kehtivad järgmisest toitetsüklist (PendingRestart)',
      actions: 'Toimingud',
      attachDisk: 'Lisa ketas',
      attachDiskTitle: 'Ketta lisamine',
      attach: 'Ühenda',
      noFreeDisks: 'Ühtegi kasutamata ketast ei ole — loo üks jaotises Virtuaalmasinad › Kasutamata kettad.',
      addCdrom: 'Lisa seade',
      addCdromTitle: 'CD/DVD-seadme lisamine',
      editCdromTitle: 'Vaheta CD/DVD-tõmmist',
      changeMedia: 'Vaheta CD/DVD-tõmmist',
      ejectMedium: 'Väljasta',
      mountGuestTools: 'Haagi TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools on haagitud',
      guestToolsClickMount: 'Paneb TVirt Guest Toolsi ISO esimesse tühja CD/DVD-seadmesse',
      guestToolsClickUnmount: 'Klõpsa, et väljastada — seade jääb tühjana alles',
      guestToolsNoSlot: 'Ühtegi tühja CD/DVD-seadet ei ole — lisa seade (või väljasta mõni kandja), et TVirt Guest Tools haakida',
      guestToolsSkew: 'Ühendatud v{pinned}; sõlm {node} pakub nüüd v{current}: väljasta ja ühenda uuesti, et uuendada',
      ejectGuestTools: 'Väljasta TVirt Guest Tools (seade jääb tühjana alles)',
      guestToolsEjectConfirmTitle: 'Kas väljastada TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Kandja väljastatakse töötavast VM-ist — CD/DVD-seade jääb tühjana alles.',
      applyLive: 'Rakenda kohe (VM töötab)',
      addNic: 'Lisa liides',
      addNicTitle: 'Võrguliidese lisamine',
      editNicTitle: 'Muuda võrguliidest',
      bridgeChip: 'bridge',
      cable: 'Virtuaalne kaabel',
      plug: 'Ühenda virtuaalne kaabel',
      unplug: 'Ühenda virtuaalne kaabel lahti',
      remove: 'Eemalda',
      removeTitle: 'Kas eemaldada {device}?',
      removeBody: 'Töötaval VM-il rakendub muudatus järgmisel toitetsüklil. Kettad ja tõmmised ühendatakse lahti, mitte kunagi ei kustutata.'
    }
  }
}
